import permissions from '~/assets/js/enums/ModeratorPermissions'

export default [
  {
    icon: 'fal fa-home-lg-alt',
    title: 'dashboard.nav.dashboard',
    route: { name: 'dashboard' }
  },
  {
    icon: 'fal fa-chart-pie-alt',
    title: 'dashboard.nav.statistics',
    route: { name: 'dashboard-statistics' },
    feature: 'statistics',
    permission: permissions.STATISTICS
  },
  {
    icon: 'fal fa-trophy',
    title: 'dashboard.nav.achievements',
    route: { name: 'dashboard-achievements' }
  },
  {
    icon: 'fal fa-layer-group',
    title: 'dashboard.nav.overlays',
    route: { name: 'dashboard-all-overlays' }
  },
  {
    icon: 'fal fa-siren',
    title: 'dashboard.nav.alerts.title',
    route: { name: 'dashboard-alerts' },
    sections: [
      {
        title: 'dashboard.nav.alerts.alert_set',
        route: { name: 'dashboard-alerts-alert-sets' },
        items: [],
        permission: permissions.ALERTS,
        addSetLink: { name: 'dashboard-alerts-alert-sets-id', params: { id: 'new' } }
      },
      {
        title: 'dashboard.nav.alerts.overview',
        items: [
          {
            title: 'dashboard.nav.alerts.alerts_library',
            permission: permissions.ALERTS,
            route: { name: 'dashboard-alerts-choose' }
          }
        ]
      }
    ]
  },
  {
    icon: 'fal fa-shopping-cart',
    title: 'dashboard.nav.stream_elements.title',
    sections: [
      {
        title: '',
        items: [
          {
            title: 'dashboard.nav.stream_elements.downloads',
            route: { name: 'dashboard-stream-elements-downloads' }
          }
        ]
      },
      {
        title: 'dashboard.nav.stream_elements.banners',
        items: [
          {
            title: 'dashboard.nav.stream_elements.twitch_profile_banners',
            route: { name: 'dashboard-stream-elements-twitch-profile' }
          }
        ]
      },
      {
        title: 'dashboard.nav.stream_elements.panels',
        items: [
          {
            title: 'dashboard.nav.stream_elements.twitch_panels',
            route: { name: 'dashboard-stream-elements-twitch-panels' }
          }
        ]
      },
      {
        title: 'dashboard.nav.stream_elements.emotes',
        items: [
          {
            title: 'dashboard.nav.stream_elements.subscriber_emotes',
            route: { name: 'dashboard-stream-elements-twitch-emotes' }
          }
        ]
      }
    ]
  },
  {
    icon: 'fal fa-layer-plus',
    title: 'dashboard.nav.extensions.title',
    sections: [
      {
        title: 'dashboard.nav.extensions.twitch',
        items: [
          {
            title: 'dashboard.nav.extensions.overview',
            route: { name: 'dashboard-extensions-twitch' },
            permission: permissions.EXTENSIONS
          }
        ]
      }
    ]
  },
  {
    // eslint-disable-next-line max-len
    svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29.913 36.465" class="w-full h-full"><path d="M6.2 36.465A21.364 21.364 0 0 1 29.913 1.818v10.924A12.2 12.2 0 0 0 12.7 30.023l6.418 6.442Zm23.711-8.788V12.743L15.033 27.677Z" fill="currentColor"/></svg>',
    title: 'Epidemic Sound',
    feature: 'epidemic-sound',
    startsWith: true,
    sections: [
      {
        title: '',
        items: [
          {
            title: 'dashboard.nav.music.music',
            route: { name: 'dashboard-jukebox-genres' }
          },
          {
            title: 'dashboard.nav.music.playlist',
            route: { name: 'dashboard-jukebox-playlists' }
          },
          {
            title: 'dashboard.nav.music.sound_effects',
            route: { name: 'dashboard-jukebox-sound-effects' }
          }
        ]
      }
    ]
  },
  {
    icon: 'fal fa-comment-alt-lines',
    title: 'dashboard.nav.chatbot.title',
    sections: [
      {
        title: 'dashboard.nav.chatbot.settings',
        items: [
          {
            title: 'dashboard.nav.chatbot.auto_moderation',
            route: { name: 'dashboard-chatbot-moderation' },
            permission: permissions.CHATBOT
          },
          {
            title: 'dashboard.nav.chatbot.analysis',
            route: { name: 'dashboard-chatbot-analysis' },
            permission: permissions.CHATBOT
          }
        ]
      },
      {
        title: 'dashboard.nav.chatbot.features',
        items: [
          {
            title: 'dashboard.nav.chatbot.commands',
            route: { name: 'dashboard-chatbot-commands' },
            permission: permissions.CHATBOT
          },
          {
            title: 'dashboard.nav.chatbot.timers',
            route: { name: 'dashboard-chatbot-timers' },
            permission: permissions.CHATBOT
          },
          {
            title: 'dashboard.nav.chatbot.giveaways',
            route: { name: 'dashboard-chatbot-giveaway' },
            permission: permissions.CHATBOT
          }
        ]
      }
    ]
  },
  {
    icon: 'fal fa-tools',
    title: 'dashboard.nav.tools.title',
    sections: [
      {
        title: 'dashboard.nav.tools.streaming',
        items: [
          { title: 'dashboard.nav.tools.goal_bars', route: { name: 'dashboard-tools-goal-bars' } },
          { title: 'dashboard.nav.tools.countdown', route: { name: 'dashboard-tools-countdown' } }
        ]
      },
      {
        title: 'dashboard.nav.tools.features',
        items: [
          {
            title: 'dashboard.nav.tools.linkspree',
            route: { name: 'dashboard-tools-linkspree' },
            feature: 'linkspree',
            permission: permissions.LINKSPREE
          },
          { title: 'dashboard.nav.tools.donation', route: { name: 'dashboard-tools-donation' } },
          { title: 'dashboard.nav.tools.schedule_generator', route: { name: 'dashboard-tools-schedule-generator' } }
        ]
      }
    ]
  },
  {
    icon: 'fal fa-graduation-cap',
    noActingUser: true,
    title: 'dashboard.nav.user_menu.tutorials',
    href: `https://www.own3d.academy/courses/own3d-pro-setup/?${new URLSearchParams({
      utm_source: 'own3dpro',
      utm_medium: 'referral',
      utm_campaign: 'streamtv',
      utm_content: 'website'
    })}`
  },
  {
    title: 'dashboard.nav.get_premium.title',
    // eslint-disable-next-line max-len
    svg: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" class="w-full h-full"><path fill="currentColor" d="M187 69c7 6 7 16 0 22l-96 96c-6 7-16 7-22 0-7-6-7-16 0-22l96-96c6-7 16-7 22 0zm-64 214c-6 7-16 7-22 0-7-6-7-16 0-22l160-160c6-7 16-7 22 0 7 6 7 16 0 22L123 283zM0 64C0 29 29 0 64 0h256c35 0 64 29 64 64v284c0 13-5 25-14 34L254 498c-9 9-21 14-34 14H64c-35 0-64-29-64-64V64zm352 0c0-18-14-32-32-32H64c-18 0-32 14-32 32v384c0 18 14 32 32 32h128V368c0-26 22-48 48-48h112V64zm0 288H240c-9 0-16 7-16 16v112l7-5 116-116 5-7z"/></svg>',
    route: { name: 'dashboard-checkout' },
    noActingUser: true,
    hasPermission: (user) => {
      return !user.subscription.is_active
    }
  },
  {
    icon: 'fal fa-badge',
    title: 'dashboard.nav.partner',
    route: { name: 'dashboard-partner-overview' },
    startsWith: true,
    hasPermission: (user) => {
      return user.is_partner
    }
  }
]
